export const TRANSFER_MODAL = 'transferModal'

export const TOOLTIP_SHOW_IN_SECONDS = 0.5

export enum ConnectionGuideEvents {
  SHOW_TOAST = 'show-toast',
  TOGGLE_CONNECT_TYPE = 'toggle-connect-type',
}

// 用于js模块中，需要和constants.styl文件中的同名变量保持同步
export const H5_WIDTH_THRESHOLD = '680px'
